/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Sticky ATC
setTimeout(function () {
  var stcBtn = document.querySelector('.ProductForm__BuyButtons');
  if (stcBtn) {
    var stop = (stcBtn.offsetTop + 50);

    window.onscroll = function (e) {
      var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        if (scrollTop >= stop) {
          stcBtn.classList.add('stick');
        } else {
          stcBtn.classList.remove('stick');
        }
      } else {
        var galery = document.querySelector('.Product__Gallery');
        var prod = document.querySelector('.Product__InfoWrapper .Product__Info ');
        let box = galery.offsetHeight;
        let pb = prod.offsetHeight;

        if (scrollTop >= box-pb+260) {          
          stcBtn.classList.add('stick');
          document.querySelector('.template-product').classList.add('aj-sticky-btn');
        } else {
          stcBtn.classList.remove('stick');
          document.querySelector('.template-product').classList.add('aj-sticky-btn');
        }
      }
    }

    window.dispatchEvent(new CustomEvent('scroll'));
  }
}, 500);